import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledActivitiesContainer = styled.div`
    margin-bottom: 20px;

    @media ${breakpoints.xs} {
        margin-top: 16px;
    }
`;

export const StyledBtnShowMore = styled.button`
    background: var(--color-white);
    border-bottom-left-radius: var(--radius-10);
    border-bottom-right-radius: var(--radius-10);
    width: 100%;
    padding: 14px;
    font-size: var(--size-14);
    font-weight: bold;
    color: var(--color-secondary);
    text-transform: uppercase;
    cursor: pointer;
    border: none;
`;
